import { ALL_ROLES_FLAG } from '../firewall-rule-form/FirewallRuleForm.queries.ts';
import type { FirewallRuleFormValues } from '../types.ts';

/**
 * Tests a list of rules to determine if any of them are overly-broad,
 * meaning that they allow any protocol on any port, without restrictions for role ID or tag.
 */
export function hasAnyAnyAllRule(rules: FirewallRuleFormValues[]): boolean {
  for (const r of rules) {
    if (r.protocol === 'ANY' && r.portRange === null && r.allowedRoleID === ALL_ROLES_FLAG && r.tags.length === 0) {
      return true;
    }
  }

  return false;
}
